import React from 'react'
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import AboutSidebar from './AboutSidebar'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload';
const Mission = () => {
  return (
    <>
      <Header />   <div className="inner_slider">
        <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SXSBPB/public/Images/inner_slider.jpg" className="img-fluid inner_slider_img" alt="St. Xaviers Bathinda" /> </LazyLoad>
        <div className="row bread_cumb">
          <h2>Mission</h2>
          <div className="theme-heading">
            <span className="colorW marB10"><i className="bi bi-building"></i></span>
          </div>
          <h5><Link to="/">Home <i className="bi bi-arrow-right"></i> </Link><span> About Us <i className="bi bi-arrow-right"></i> Mission</span></h5>
        </div>

      </div>
      <div className="innerpage">
        <div className="row inner_cont">
          <div className="col-lg-9 col-md-8 col-sm-12 col-12">
            <p>Excellence in Education; Development of Scientific Temper; Shaping of Individual Personality and Building a Responsible Humankind.</p>
            <div className="clr"></div>
          </div>
          <AboutSidebar />
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Mission
